import { DatableTrace, ServiceGroup } from '@ui/interfaces'
import {
  FullTraceQuery,
  SpansByServiceQuery,
  TraceAttributeGroupQuery,
  TraceServiceGroupQuery,
  TracesWithAttributeValueQuery,
} from '@ui/loaders/trace'

interface UseTraceQueriesProps {
  timeRange: { startTime: string; endTime: string }
  whereClauseServices: string
  whereClauseAttributes: string
  orderBy: { column: string; direction: string }
  selectedGroup?: ServiceGroup | null
  selectedRootTrace?: DatableTrace | null
  attribute?: string
  value?: string
  limit?: number
}

export const useTraceQueries = ({
  timeRange,
  whereClauseServices,
  whereClauseAttributes,
  orderBy,
  selectedGroup,
  selectedRootTrace,
  attribute,
  value,
  limit,
}: UseTraceQueriesProps) => {
  const { loading: traceServiceGroupLoading, data: traceServiceGroupQueryData } = TraceServiceGroupQuery({
    endTime: timeRange.endTime,
    startTime: timeRange.startTime,
    where: whereClauseServices,
    from: '',
    offset: 0,
    limit: limit ?? 100,
    orderBy: { column: orderBy.column, direction: orderBy.direction },
  })

  const { loading: spansByServiceLoading, data: spansByServiceQueryData } = SpansByServiceQuery({
    startTime: timeRange.startTime,
    serviceName: selectedGroup?.serviceName ?? '',
    name: selectedGroup?.name ?? '',
  })

  const { data: fullTraceQueryData } = FullTraceQuery({
    traceId: selectedRootTrace?.trace_id ?? '',
  })

  const { loading: spanAttributesLoading, data: spanAttributesQueryData } = TraceAttributeGroupQuery({
    startTime: timeRange.startTime,
    endTime: timeRange.endTime,
    limit: limit ?? 25,
    offset: 0,
    where: whereClauseAttributes,
    orderBy: { column: orderBy.column, direction: orderBy.direction },
  })

  const { loading: tracesWithAttributeValueLoading, data: tracesWithAttributeValueQueryData } =
    TracesWithAttributeValueQuery({
      startTime: timeRange.startTime,
      endTime: timeRange.endTime,
      attribute: attribute ?? '',
      value: value ?? '',
      limit: limit ?? 100,
    })

  return {
    traceServiceGroupLoading,
    traceServiceGroupQueryData,

    spansByServiceLoading,
    spansByServiceQueryData,

    fullTraceQueryData,

    spanAttributesLoading,
    spanAttributesQueryData,

    tracesWithAttributeValueLoading,
    tracesWithAttributeValueQueryData,
  }
}
